
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project-gallery/[categoryslug]/[slug]",
      function () {
        return require("private-next-pages/project-gallery/[categoryslug]/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project-gallery/[categoryslug]/[slug]"])
      });
    }
  